import useInitialLoading from "app/hooks/useInitialLoading";
import { Redirect } from "expo-router";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useInitialLoading();

  if (!isAuthenticated && !loading) {
    return <Redirect href="/(guest)" />;
  }

  return <>{children}</>;
}
